import { Box } from '@mui/material'
import React from 'react'
import Contact from '../Components/Contact/Contact'

const ContactPage = () => {
  return (
    <Box>
      <Contact />
    </Box>
  )
}

export default ContactPage